export const IMG_TYPE_PANOLENS = 'panolens';
export const IMG_TYPE_IMAGE = 'image';
export const INPUT_TYPE_FILE = 'file';
export const INPUT_TYPE_COLOR = 'color';
export const INPUT_TYPE_COLORSELECT = 'colorselect';
export const INPUT_COLOR_SETTINGS_NAME = 'colorSetting';
export const INPUT_OPACITY_SETTINGS_NAME = 'opacitySetting';
export const STATIC_FIELD_IN_DATE = '__in_date';
export const STATIC_FIELD_OUT_DATE = '__out_date';
export const ES_APP_VERSION = '0.00.1';
